import {Component, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {ActivatedRoute, Router} from "@angular/router";
import {Compbaser} from "../../../components/compbaser";
import {actionAccountSocialLoginRequest} from "../../../store/actions/user.actions";
import {ToastrService} from "ngx-toastr";
import {AuthUserService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {FacebookLoginProvider, GoogleLoginProvider, SocialUser} from "@abacritt/angularx-social-login";
import {EnumStudioType, IAppStatic, loginUrlType} from "../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {LoginForm} from "../../../models";

enum EnumCreateViewMode { CREATE, LOADING}

@Component({
    selector: 'app-started-create',
    templateUrl: './started-create.component.html',
    styleUrls: ['./started-create.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({opacity: 0}),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})

// to be used: https://github.com/DethAriel/ng-recaptcha
// https://stackblitz.com/edit/ng-recaptcha-example
// https://github.com/DethAriel/ng-recaptcha#installation

export class StartedCreateComponent extends Compbaser implements OnInit {
    m_viewMod = EnumCreateViewMode;
    m_currentViewMode = EnumCreateViewMode.CREATE;
    templateSampleId;
    mode: loginUrlType;
    socialUser: SocialUser;
    socialMode = false;
    socialModeChecking = false;
    appSettings: IAppStatic;
    resellerId;

    constructor(private authUserService: AuthUserService, private storeSelectorsService: StoreSelectorsService,
                public router: Router, private localStore: LocalStoreService,
                private route: ActivatedRoute, private toastr: ToastrService,
                private translocoService: TranslocoService) {

        super();
        this.cod(
            storeSelectorsService.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
        this.cod(
            this.storeSelectorsService.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.templateSampleId = this.localStore.getStorageConfig().socialUserPendingTemplateId;
                })
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                this.mode = routeParams.get('mode') as loginUrlType;
            })
        );
        this.cod(
            this.storeSelectorsService.getResellerId(this.localStore)
                .subscribe((i_resellerId: number) => {
                    this.resellerId = i_resellerId;
                })
        );
    }

    ngOnInit() {
        this.cod(
            this.storeSelectorsService.getSocialUser(true)
                .subscribe((i_values) => {
                    /** social user and serverReply received confirming social authenticated **/
                    if (i_values.a && i_values.b) {
                        this.socialMode = true;
                        this.socialUser = i_values.a;
                        // this.socialServerReply = i_values.b;
                    }
                })
        );
    }

    onSubmit(loginForm: LoginForm) {
        let businessName;
        let userName;
        let password;
        let contactEmail;

        if (this.socialMode) {
            businessName = '';
            userName = this.socialUser.email;
            password = null;
            contactEmail = userName;
        } else {
            businessName = '';
            userName = loginForm.username;
            password = loginForm.password;
            contactEmail = '';
        }
        this.m_currentViewMode = EnumCreateViewMode.LOADING;
        this.toastr.success(this.translocoService.translate('toast.creatingAcc', {}, this.translocoService.getActiveLang()));
        const studioType: EnumStudioType = this.localStore.getItem('ILocalStorageConfig').socialUserPendingStudioType;
        this.authUserService.createUser(businessName, userName, password, contactEmail, this.templateSampleId, this.resellerId, studioType);
    }

    onLoginAmazonPopup(e) {
        const newWin = window.open(`${this.appSettings.globalService}/AmazonLogin`, "_blank", "width=640,height=480,location=0");
        if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
            this.toastr.error(this.translocoService.translate('toast.problemLoadingAdnet', {}, this.translocoService.getActiveLang()));
        }
        return false;
    }

    signInWithFB(): void {
        this.socialModeChecking = true;
        this.authUserService.getSocialAuthService().signIn(FacebookLoginProvider.PROVIDER_ID).then(socialUser => {
            console.log('getSocialAuthService ' + socialUser);
            this.verifyToken(socialUser);
        });
    }

    signInWithGoogle(): void {
        this.socialModeChecking = true;
        this.authUserService.getSocialAuthService().signIn(GoogleLoginProvider.PROVIDER_ID).then(socialUser => {
            console.log('getSocialAuthService ' + socialUser);
            this.verifyToken(socialUser);
        });
    }

    verifyToken(i_socialUser: SocialUser) {
        this.storeSelectorsService.dispatch(actionAccountSocialLoginRequest({payload: i_socialUser}));
    }

    resolved(captchaResponse: string) {
        console.log(`Resolved captcha with response: ${captchaResponse}`);
        // this.captchaPass = true;
    }

    goBack() {
        this.authUserService.backToLogin();
    }
}


// this.cod(
//     storeSelectorsService.getSocialUserServerReply()
//         .subscribe((i_socialServerReply: ISocialServerReply) => {
//             if (i_socialServerReply.exists)
//                 return;
//             this.socialServerReply = i_socialServerReply;
//             this.m_currentViewMode = EnumCreateViewMode.LOADING;
//             if (i_socialServerReply.profile) {
//                 let userName;
//                 if (i_socialServerReply.profile.access) {
//                     userName = i_socialServerReply.socialUser.email;
//                 } else if (i_socialServerReply.profile.iss) {
//                     userName = i_socialServerReply.profile.email;
//                 } else {
//                     userName = i_socialServerReply.profile.emails[0].value;
//                 }
//                 /**
//                  we load this component twice due to router double entry so in such mode so ignore one to avoid multiple server calls
//                  {path: 'create', component: StartedCreateComponent},
//                  {path: 'create/:mode', component: StartedCreateComponent},
//                  **/
//                 // if (this.mode == "CHECKOUT") return;
//                 // this.toastr.info(this.translocoService.translate('toast.createAccount', {}, this.translocoService.getActiveLang()));
//                 // this.authUserService.createUser('Signage', userName, null, userName, this.templateSampleId);
//
//             } else {
//                 this.toastr.error(this.translocoService.translate('toast.probSocialRep', {}, this.translocoService.getActiveLang()));
//                 this.m_currentViewMode = EnumCreateViewMode.CREATE;
//             }
//         })
// );
